const PROFILE_TYPE = {
  ENROLLMENT: 'enrollment',
  PROFILE_DEPENDENCY: 'profileDependency',
  PROFILE_DEPLOYMENTS: 'profileDeployments',
  MASTER_PROFILE: 'masterProfile',
  APPSETUP: 'appSetup',
  APP_MANAGEMENT: 'appManagement',
  THIRD_PARTY_APPS: 'thirdPartyApps',
  DESIGNER_CONFIGURATOR: 'designerConfigurator',
  EHS_DESIGN_CONFIGURATOR: 'ehsConfigurator',
  LOGGER: 'Logger',
  LOGGER_CANCEL: 'loggerCancel',
  DEVICESETTINGS: 'deviceSettings',
  CM: 'contentManagement'
}
const COLLECTION_PATH = '/feature_flag/profile_dependency/'
const GENERAL_PAGES = [
  'New Device Setup',
  'My Devices',
  'Device Users',
  'Device Settings',
  'Profile Dependency',
  'My Apps',
  'Design Studio',
  'Android Updates',
  'Licensing',
  'Remote Rxlogger',
]
const PROFILE_LEVEL_PAGES = ['My Services', 'Users']
const PAGES_LIST = {
  GENERAL_PAGES,
  PROFILE_LEVEL_PAGES,
  MYAPPS_TARGET_DEVICE: 'MyAppsTargetDevice',
  DEVICE_SETTING_TARGET_DEVICE: 'DeviceSettingTargetDevice',
  ALL_PAGES: [...GENERAL_PAGES, ...PROFILE_LEVEL_PAGES],
}

const PROFILE_DEPENDENCY = 'Profile Dependency'

const DATABASE = {
  TENANT_COL: 'tenants',
  DEPLOYMENT_COL: 'deployments',
  CONFIGS_COL: 'configs',
  PROFILES_COL: 'profiles',
  SCHEDULES_COL: 'schedules',
  CONTENTS_COL: 'contents',
  PROFILEDATA_COL: 'profileData',
  PROFILE_UI_DATA: 'UIData',
  PROFILE_DEVICE_DATA: 'deviceData',
  ASSIGNED_DEVICES: 'assignedDevices',
  GROUPS: 'groups',
  DEVICES: 'devices',
  USERS: 'users',
  REMOTE_CONTROL: 'remoteControl',
  COLUMN_WIDTH: 'columnWidth',
  CONSOLE_INFO_DOC: 'consoleInfo',
  REMOTE_INFO_DOC: 'remoteInfo',
  DEVICE_PROPERTIES_DOC: 'deviceProperties',
  LICENSES: 'licenses',
  DEVICE_APPS: 'apps',
  DEVICE_APPS_ISTALLED: 'appsInstalled',
  SERVER_CONFIG_COL: 'server_config',
  APP_LATEST_VERSIONS_DOC: 'appLatestVersions',
  CLIENT_CONFIG_COL: 'client_config',
  SUPPORTED_MODELS: 'supportedModels',
  TENANT_CONFIG_COL: 'tenantConfig',
  OTHER_DNA_PRODUCTS_COL: 'otherDnaProducts', // EDCL-31
  LICENSE_CONFIG: 'licenseConfig',
  CONNECTED_SERVICES_COL: 'connectedServices',
  AKAMAI_SERVICES_DOC: 'akamaiServices',
  LGE_COL: 'LGE',
  EB_TRIAL_LICENSE_PREF: 'EBTrialLicensePref',
  DEMO_VIDEOS_REFERENCE: 'demoVideosReference',
  ZEBRAAPPS_COL: 'zebraApps',
  VERSION_COL: 'versions',
  RESOURCES_COL: 'resources',
  PACKAGENAME: 'com.zebra.mdna.oemconfig.release',
  VERSION: '63',
  APPRESTRICTIONJSON: 'appRestrictionJSON',
  ARTIFACT_DATA: 'artifactData',
  DASHBOARD: 'dashboard',
  BATTERY_HEALTH_STATUS: 'batteryHealthStatus',
  RELEASED_FEATURE_DETAILS: 'releasedFeatureDetails',
  LATEST_ARTIFACT: 'latestArtifact',
  OTHER_EMM_DETAILS: 'otherEmmDetails',
  DEVICE_COUNTS: 'deviceCounts',
  USER_PREFERENCE: 'userPreference',
  PAGE_PREFERENCE: 'pagePreference',
  TABLE_PREFERENCE: 'tablePreference',
  SUPPORTED_BUILDS: 'supportedBuilds',
  MINIMUM_SUPPORTED_BUILDS: 'minimumSupportedBuilds',
  DEVICE_USERS_COL: 'deviceUsers',
  FEATURE_PERMISSION: 'featurePermission',
  MY_APPS: 'myApps',
  ROLE_CONFIG: 'roleConfig',
  USER_PERMISSIONS: 'userPermissions',
  PG_TENANT_CONFIG_COL: 'tenantConfig',
  PG_CONFIG_COL: 'config',
  PG_CONFIG_DOC: 'passwordManager',
}

const LGE = {
  DEPLOYMENT_SIMPLE_STATUS: process.env.REACT_APP_DEPLOYMENT_SIMPLE_STATUS,
  CANCEL_DEPLOYMENT: process.env.REACT_APP_CANCEL_DEPLOYMENT,
  DEPLOYMENT_DETAILED_STATUS: process.env.REACT_APP_DEPLOYMENT_DETAILED_STATUS,
  SORT_API_URL: process.env.REACT_APP_SORT_API,
  DEVICES_API: process.env.REACT_APP_DEVICES,
  DEPLOYMENT_STATUS: {
    CREATED: 'CREATED',
    INPROGRESS: 'INPROGRESS',
    COMPLETED: 'COMPLETED',
    NOTCOMPLETED: 'NOTCOMPLETED',
  },
}

const LICENSES = {
  LICENSE_ERROR: 'License Required',
}

const VALID_HOST = process.env.REACT_APP_VALID_HOST
const DEFAULT_SYSTEM_ROLES = ['Admin', 'Manager']

const DESIGNS = {
  ADD_DESIGN: process.env.REACT_APP_ADD_DESIGNS,
  GET_DESIGNS: process.env.REACT_APP_GET_DESIGNS,
}

const CHECK_LATEST_APP_BASE_VERSION = [
  'ZDPI',
  'oemConfig',
  'FOTA',
  'com.zebra.commontransportlayer',
  'com.zebra.commontransportlayer_aosp',
]

const CHECK_PACKAGE_SHORT_FORM_BASE_VERSION = {
  CTL: 'com.zebra.commontransportlayer',
  CTL_AOSP: 'com.zebra.commontransportlayer_aosp',
  ZDPI: 'ZDPI',
  oemConfig: 'oemConfig',
  FOTA: 'FOTA',
}

const CHECK_LATEST_APP_VERSION = ['ZDPI', 'oemConfig', 'FOTA', 'com.zebra.commontransportlayer']
const CHECK_LATEST_APP_VERSION_A14 = ['oemConfig', 'FOTA', 'com.zebra.commontransportlayer']
const CHECK_LATEST_APP_VERSION_THIRD_PARTY = ['com.zebra.commontransportlayer']

const CHECK_PACKAGE_SHORT_FORM = {
  CTL: 'com.zebra.commontransportlayer',
  ZDPI: 'ZDPI',
  oemConfig: 'oemConfig',
  FOTA: 'FOTA',
}
const CHECK_PACKAGE_SHORT_FORM_A14 = {
  CTL: 'com.zebra.commontransportlayer',
  oemConfig: 'oemConfig',
  FOTA: 'FOTA',
}
const CHECK_PACKAGE_SHORT_FORM_THIRD_PARTY = {
  CTL: 'com.zebra.commontransportlayer',
}

const DOC_URL_PROD = 'https://techdocs.zebra.com/zebradna/6-7'
const DOC_URL_STAGE = 'https://zebra-stage.github.io/zebradna/6-7'

const RESOURCES = {
  TECHDOCLINK: process.env.REACT_APP_ENV === 'production' ? `${DOC_URL_PROD}` : `${DOC_URL_STAGE}`,

  TECHDOCLINK_ABOUT:
    process.env.REACT_APP_ENV === 'production'
      ? `${DOC_URL_PROD}/about/`
      : `${DOC_URL_STAGE}/about/`,
  TECHDOCLINKREGISTERUSERGUIDE:
    process.env.REACT_APP_ENV === 'production'
      ? `${DOC_URL_PROD}/setup/#iiregisterwithzebracom`
      : `${DOC_URL_STAGE}/setup/#iiregisterwithzebracom`,
  SYSTEM_REQUIREMENT_LINK:
    process.env.REACT_APP_ENV === 'production'
      ? `${DOC_URL_PROD}/setup/#systemrequirements`
      : `${DOC_URL_STAGE}/setup/#systemrequirements`,
  GOOGLE_DRIVE_HELP_LINK:
    process.env.REACT_APP_ENV === 'production'
      ? `${DOC_URL_PROD}/setup/#myservicesnotes`
      : `${DOC_URL_STAGE}/setup/#myservicesnotes`,
  DEVICE_AUTO_NAMING:
    process.env.REACT_APP_ENV === 'production'
      ? `${DOC_URL_PROD}/usage/#deviceautonaming`
      : `${DOC_URL_STAGE}/usage/#deviceautonaming`,
}

let CONTENT_TYPE = {
  ENCODED: 'application/x-www-form-urlencoded',
  JSON: 'application/json',
}

const JOB_STATUS = {
  INPROGRESS: 'inProgress',
  COMPLETED: 'completed',
  FAILED: 'failed',
  CREATED: 'created',
  CANCELLED: 'cancelled',
  SUCCESS: 'success',
  EXCEPTION: 'exception',
}

const JOB_STATUS_CODE = {
  4000: 'Device is not enrolled',
  4001: 'Bsp Version not found for this device. Please contact Administrator',
  4002: 'Patch Details not found for this device.. Please contact Administrator',
  4003: 'Device Information not found',
  4004: 'More than one record found for deriving the base Artifact. Please contact the Administrator.',
  4005: 'Device is already updated',
  4006: 'Artifact data not found for this device. Please contact Administrator. Arguments are in following format [baseline, patch, deviceModel, artifactSubType, ArtifactId]',
  4007: 'Artifact data not found for targeted. Please contact Administrator. Arguments are in following format [ArtifactId]',
  4008: 'Artifact data not found for targeted OS,patch,bsp version. Please contact Administrator. Arguments are in following format [deviceModel,TargetBsp,TargetPatch,TargetArtifactSubType,TargetOS]',
  4009: 'This Device does not support LGE. Please contact Administrator',
  4010: 'LGE is not supported in this BSP/Patch version you are trying to upgrade.Please contact Administrator',
  4011: 'This Device does not support LGE. Please contact Administrator',
  4012: 'Artifact data support Issue. Please contact Administrator',
  4013: 'Device is not entitled',
  4014: 'Device not report any status',
  4015: 'Target security patch level is older than source. Please select the latest one.',
  4016: 'More than one record found for deriving target Artifact. Please contact the Administrator.',
  4017: 'Provided device artifact sub type does not match with target artifact sub type',
  5000: 'NO DEPLYEMENT ID TO CANCEL',
  5001: 'CANCEL NOT FOR CURRENT DEPLOYEMENT ID',
  5002: 'CANCEL NOT POSSIBLE',
  5003: 'CONCURRENT REACH APPLY CANCEL',
  5004: 'SOME DEPLOYMENT IS INPROGRESS',
  5006: 'PROFILE IS NULL',
  5007: ' MODE NOT SUPPORTING',
  5008: 'BSP RESTRICTION FOR SPACE',
  5009: 'ZERO FILE SIZE',
  5010: 'REQUIRED SPACE NOT AVAILABLE',
  5011: 'REQUIRED SPACE CANNOT BE ZERO',
  5012: 'MEDIA SERVER NULL',
  5013: 'TOKEN NULL',
  5014: 'TOKEN KEY NULL',
  5015: 'TOKEN VALUE NULL',
  5016: 'CREDENTIALS NULL',
  5017: 'USERNAME NULL',
  5018: 'PASSWORD NULL',
  5019: 'ARTIFACT NULLFOTA',
  5020: 'ARTIFACT ZIP EXTENSION',
  5021: 'UPL ARTIFACT',
  5022: 'CAN NOT BE DUPLICATE',
  5023: 'ARTIFACT URL NULL',
  5024: 'ARTIFACT URL INCORRECT',
  5025: 'SCHEDULE NULL EMPTY',
  5026: 'MODE NULL EMPTY',
  5027: 'CURRENTDATE IS AFTER ENDDATE',
  5028: 'STARTDATE CANNOT COME AFTER ENDDATE',
  5029: 'INVALID DATE',
  5030: 'ENDDATE CAN NOT BE EMPTY',
  5031: 'INSTALL NULL',
  5032: 'NOT SUPPORTED',
  5033: 'SCHEDULE STARTDATE CANNOT EMPTY',
  5034: 'SCHEDULE ENDDATE CANNOT EMPTY',
  5035: 'DOWNLOAD STARTDATE CANNOT EMPTY',
  5036: 'LASTPOSTPONE DATE CANNOT EMPTY',
  5037: 'INSTALL STARTDATE CANNOT EMPTY',
  5038: 'SCHEDULE STARTDATE CANNOT COME AFTER STARTINSTALL DATE',
  5039: 'STARTINSTALLDATE CANNOT COME AFTER ENDSCHEDULEDDATE',
  5040: 'SCHEDULED START DATE CANNOT COME AFTERLASTPOSTPONEMENTDATE',
  5041: 'STARTDOWNLOADATE CANNOT COME AFTER STARTINSTALLDATE',
  5042: 'LASTPOSTPONEMENTDATE CAN NOT COME AFTER ENDSCHEDULEDDATE',
  5043: 'STARTDOWNLOADDATE CAN NOT COME AFTER LASTPOSTPONEMENTDATE',
  5044: 'INVALID LEAD TIME',
  5045: 'INVALID INSTALL TIMEWINDOW START',
  5046: 'INVALID INSTALL TIMEWINDOW END',
  5047: 'EQUAL INSTALL TIMEWINDOWSTART TIMEWINDOWEND',
  5048: 'TIMEWINDOW FINISHED FOR LAST DATE',
  5049: 'DOWNLOAD CANNOT NULL',
  5050: 'INVALID DOWNLOAD TIMEWINDOW START',
  5051: 'INVALID DOWNLOAD TIMEWINDOW END',
  5052: 'EQUAL DOWNLOAD TIMEWINDOWSTART TIMEWINDOWEND',
  5053: 'SCHEDULED STARTDATE CANNOT COME AFTER STARTDOWNLOADDATE',
  5054: 'STARTDOWNLOADDATE CA N NOT COME AFTER ENDSCHEDULED DATE',
  5055: 'NETWORK CANNOT BE EMPTY',
  5056: 'INVALID NETWORK TYPE',
  5057: 'INVALID BATTERY MINIMUM LEVEL',
  5058: 'INVALID BATTERY LEVEL',
  5059: 'TARGET DOWNLOADPATH NULL EMPTY',
  5060: 'UNSUPPORTED TARGET DOWNLOAD PATH',
  5061: 'TARGET BUILDID NULL EMPTY',
  5062: 'TARGET PATCHLEVEL NULL EMPTY',
  5063: 'ARTIFCATID NULL EMPTY',
  5064: 'RESET NULL EMPTY',
  5065: 'RESET UNSUPPORTED',
  5066: 'MODE UNSUPPORTED',
  5067: 'DEPLOYEMENT NULL EMPTY',
  5068: 'TRANSACTION NULL EMPTY',
  5069: 'TIMESTAMP NULL EMPTY',
  5070: 'ACTION NULL EMPTY',
  5071: 'UNSUPPORTED ACTION VALUE',
  5072: 'SOURCE NULL EMPTY',
  5073: 'SCHEMA NULL EMPTY',
  5074: 'UNSUPPORTED SCHEMA',
  5075: 'INAPPRORIATE SCHEMA',
  5076: 'CONTEXT NULL',
  5077: 'ADMIN CANCEL MSG',
  5078: 'USER CANCEL DOWNLOAD',
  5079: 'INSTALL AW',
  5080: 'DOWNLOAD COMPLETE',
  5081: 'MANIFEST PROGRESS',
  5082: 'REBOOT DURINGOSUPDATE',
  5083: 'REBOOT DURING DOWNLOA D IN PROGRESS',
  5084: 'ZDS DISABLED',
  5085: 'ZDS ENABLED',
  5086: 'DOWNLOAD YET TO BEGIN',
  5087: 'DOWNLOAD IN PROGRESS',
  5088: 'DOWNLOAD PAUSED WAITING TO RETRY',
  5089: 'DOWNLOAD PAUSED WAITING FOR NETWORK',
  5090: 'DOWNLOAD PAUSED QUEUED FOR WIFI',
  5091: 'DOWNLOAD PAUSED UNK NOWN',
  5092: 'DOWNLOAD FAILED WITH FILE NOT FOUND',
  5093: 'DOWNLOAD FAILED WITH ERROR UNKNOWN',
  5094: 'DOWNLOAD FAILED WITH ERROR FILE ERROR',
  5095: 'DOWNLOAD FAILED WITH ERROR UNHANDLED HTTP CODE',
  5096: 'DOWNLOAD FAILED WITH ERROR HTTP DATA ERROR',
  5097: 'DOWNLOAD FAILED WITH ERROR TOO MANY REDIRECTS',
  5098: 'DOWNLOAD FAILED WITH ERROR INSUFFICIENT SPACE',
  5099: 'DOWNLOAD FAILED WITH ERROR DEVICE NOT FOUND',
  5100: 'DOWNLOAD FAILED WITH ERROR CANNOT RESUME',
  5101: 'DOWNLOAD FAILED WITH ERROR FILE ALREADY EXISTS',
  5102: 'DOWNLOAD FAILED WITH UNKNOWN ERROR',
  5103: 'DOWNLOAD FAILED WITH ERROR DOWNLOAD RETRY TIMEOUT',
  5104: 'DOWNLOAD FAILED WITH INDEX OUT OF BOUNDS EXCEPTION',
  5105: 'URL EMPTY',
  5106: 'EXCEPTION IN DOWNLOADING FILE',
  5107: 'OTHER OSUPDATE PROGRESS',
  5108: 'MANIFEST SUCCESS',
  5109: 'MANIFEST FAILURE',
  5110: 'MX FAILED TO REBOOT',
  5111: 'OEMINFO DOESNOT RETURN ANY VALUE',
  5112: 'END DATE IS OVER',
  5113: 'INSTALL IS TRIGGERED',
  5114: 'END DATE OVER INSTALL RULE DOES NOT MET',
  5115: 'MX IS NOT READY EVEN AFTER MAX TIME OUT',
  5116: 'MX SERVICE IS NOT AVAILABLE',
  5131: 'MX SETTINGS FAILED',
  5117: 'FOTA READY',
  5118: 'FOTA UPDATED',
  5119: 'FOTA SETINGS SET PROPERLY',
  5120: 'FOTA SERVICE DISABLED',
  5121: 'FOTA SERVICE ENABLED',
  5122: 'FOTA CLIENT NOT IN CORRECT STATE',
  5123: 'REQUEST CANCELLED',
  5124: 'DOWNLOAD FAILED',
  5125: 'INSTALL SUCCESS MSG',
  5126: 'DOWNLOAD AW',
  5127: 'INSTALL IN PROGRESS MSG',
  5128: 'INSTALL FAILURE MSG',
  5129: 'WAITING FOR REBOOT MSG',
  5130: 'INVALID SESSION ID',
  5132: 'RECVD JSON',
  5133: 'INVALID JSON DATA',
  5134: 'ZDS SERVICE DISABLED',
  5135: 'ZDS SERVICE ENABLED',
  5136: 'DOWNLOAD PENDING',
  5137: 'SECURITY EXCEPTION WHILE DOWNLOADING',
  5138: 'EXCEPTION WHILE DOWNLOADING',
  5139: 'Waiting for OS update confirmation',
  5146: 'DEVICE NOT LICENSED',
  6000: 'DOWNLOAD FAILED WITH INVALID INSTALLATION TYPE',
  6001: 'DOWNLOAD FAILED WITH INVALID PACKAGE TYPE',
  6002: 'DOWNLOAD FAILED WITH INVALID REQ PROP',
  6003: 'INSTALL FAILURE AB STREAM',
  6004: 'INSTALL FAILURE CSP',
  6005: 'NETWORK RULES NOT MET RETRYING',
  6007: 'POWER RULES NOT MET RETRYING',
  6006: 'INSTALL RULES FAILED RETRY',
  6008: 'CANCEL FAILURE ',
  1107: 'OS Update has failed to install',
  1009: 'OS Update failed due to error while copying or transferring package',
  1113: 'OS update failed to install due to exception',
  1114: 'Eject SD/USB card from Settings when update is ongoing from external SD/USB card path',
  1124: 'Trigger Streaming OTA Full Upgrade in low battery - without connecting Charging source or with connecting USB Charging source',
  1125: 'Test OTA Full Downgrade on CC enabled device',
  1201: 'OS update has cancelled due to reboot',
  1202: 'Update cancelled ',
}

const REMOTE_CONTROL_STATUS = {
  CONSOLE_OFFER_INFO: 'consoleOfferInfo',
  CONSOLE_CANDIDATE_INFO: 'consoleCandidateInfo',
  CONSOLE_SESSION_CLOSED: 'consoleSessionClosed',
  REMOTE_ANSWER_INFO: 'remoteAnswerInfo',
  REMOTE_CANDIDATE_INFO: 'remoteCandidateInfo',
  REMOTE_SESSION_CLOSED: 'remoteSessionClosed',
}

const REMOTE_CONTROL_EXCEPTIONS = {
  ACTIVE_REMOTE_CONTROL_SESSION_EXCEPTION:
    'Unable to connect; device is busy. Please try again later.',
  MX_NOT_READY_EXCEPTION: 'Device is initializing. Please wait a moment.',
  ZWC_NOT_CONFIGURED_EXCEPTION:
    'Unable to access the Desktop View. Ensure that a supported device with ZWC installed is docked in a cradle with external monitor. For a full list of supported devices, see the ',
  KTI_PACKAGE_NOT_WHITELISTED_EXCEPTION: 'Device is initializing. Please wait a moment. ',
  DEVICE_NOT_DOCKED_EXCEPTION:
    'Unable to access the Desktop View. Ensure that a supported device with ZWC installed is docked in a cradle with external monitor. For a full list of supported devices, see the Zebra Support Portal',
  SECONDARY_SCREEN_NOT_CONNECTED_EXCEPTION:
    'Unable to access the Desktop View. Ensure that a supported device with ZWC installed is docked in a cradle with external monitor. For a full list of supported devices, see the Zebra Support Portal',
  LOWER_INJECTION_SERVICE_EXCEPTION: 'Device is initializing. Please wait a moment. ',
  ACCESS_TOKEN_INVALID_EXCEPTION: 'Unable to establish RC session. ',
}

const REMOTE_CONTROL_EXCEPTION_ERRORCODE = {
  10100: REMOTE_CONTROL_EXCEPTIONS.ACTIVE_REMOTE_CONTROL_SESSION_EXCEPTION,
  10101: REMOTE_CONTROL_EXCEPTIONS.MX_NOT_READY_EXCEPTION,
  10102: REMOTE_CONTROL_EXCEPTIONS.KTI_PACKAGE_NOT_WHITELISTED_EXCEPTION,
  10103: REMOTE_CONTROL_EXCEPTIONS.ZWC_NOT_CONFIGURED_EXCEPTION,
  10104: REMOTE_CONTROL_EXCEPTIONS.DEVICE_NOT_DOCKED_EXCEPTION,
  10105: REMOTE_CONTROL_EXCEPTIONS.SECONDARY_SCREEN_NOT_CONNECTED_EXCEPTION,
  10106: REMOTE_CONTROL_EXCEPTIONS.LOWER_INJECTION_SERVICE_EXCEPTION,
  20101: REMOTE_CONTROL_EXCEPTIONS.ACCESS_TOKEN_INVALID_EXCEPTION,
  20102: REMOTE_CONTROL_EXCEPTIONS.ACCESS_TOKEN_INVALID_EXCEPTION,
  20103: REMOTE_CONTROL_EXCEPTIONS.ACCESS_TOKEN_INVALID_EXCEPTION,
  20104: REMOTE_CONTROL_EXCEPTIONS.ACCESS_TOKEN_INVALID_EXCEPTION,
  20105: REMOTE_CONTROL_EXCEPTIONS.ACCESS_TOKEN_INVALID_EXCEPTION,
  20106: REMOTE_CONTROL_EXCEPTIONS.ACCESS_TOKEN_INVALID_EXCEPTION,
  20107: REMOTE_CONTROL_EXCEPTIONS.ACCESS_TOKEN_INVALID_EXCEPTION,
  21480: REMOTE_CONTROL_EXCEPTIONS.ACCESS_TOKEN_INVALID_EXCEPTION,
  53000: REMOTE_CONTROL_EXCEPTIONS.ACCESS_TOKEN_INVALID_EXCEPTION,
  53001: REMOTE_CONTROL_EXCEPTIONS.ACCESS_TOKEN_INVALID_EXCEPTION,
  53002: REMOTE_CONTROL_EXCEPTIONS.ACCESS_TOKEN_INVALID_EXCEPTION,
  53003: REMOTE_CONTROL_EXCEPTIONS.ACCESS_TOKEN_INVALID_EXCEPTION,
  53004: REMOTE_CONTROL_EXCEPTIONS.ACCESS_TOKEN_INVALID_EXCEPTION,
  53005: REMOTE_CONTROL_EXCEPTIONS.ACCESS_TOKEN_INVALID_EXCEPTION,
  53006: REMOTE_CONTROL_EXCEPTIONS.ACCESS_TOKEN_INVALID_EXCEPTION,
  53100: REMOTE_CONTROL_EXCEPTIONS.ACCESS_TOKEN_INVALID_EXCEPTION,
  53101: REMOTE_CONTROL_EXCEPTIONS.ACCESS_TOKEN_INVALID_EXCEPTION,
  53102: REMOTE_CONTROL_EXCEPTIONS.ACCESS_TOKEN_INVALID_EXCEPTION,
  53103: REMOTE_CONTROL_EXCEPTIONS.ACCESS_TOKEN_INVALID_EXCEPTION,
  53104: REMOTE_CONTROL_EXCEPTIONS.ACCESS_TOKEN_INVALID_EXCEPTION,
  53105: REMOTE_CONTROL_EXCEPTIONS.ACCESS_TOKEN_INVALID_EXCEPTION,
  53106: REMOTE_CONTROL_EXCEPTIONS.ACCESS_TOKEN_INVALID_EXCEPTION,
  53107: REMOTE_CONTROL_EXCEPTIONS.ACCESS_TOKEN_INVALID_EXCEPTION,
  53108: REMOTE_CONTROL_EXCEPTIONS.ACCESS_TOKEN_INVALID_EXCEPTION,
  53109: REMOTE_CONTROL_EXCEPTIONS.ACCESS_TOKEN_INVALID_EXCEPTION,
  53113: REMOTE_CONTROL_EXCEPTIONS.ACCESS_TOKEN_INVALID_EXCEPTION,
  53114: REMOTE_CONTROL_EXCEPTIONS.ACCESS_TOKEN_INVALID_EXCEPTION,
  53115: REMOTE_CONTROL_EXCEPTIONS.ACCESS_TOKEN_INVALID_EXCEPTION,
  53116: REMOTE_CONTROL_EXCEPTIONS.ACCESS_TOKEN_INVALID_EXCEPTION,
  53118: REMOTE_CONTROL_EXCEPTIONS.ACCESS_TOKEN_INVALID_EXCEPTION,
  53119: REMOTE_CONTROL_EXCEPTIONS.ACCESS_TOKEN_INVALID_EXCEPTION,
  53200: REMOTE_CONTROL_EXCEPTIONS.ACCESS_TOKEN_INVALID_EXCEPTION,
  53201: REMOTE_CONTROL_EXCEPTIONS.ACCESS_TOKEN_INVALID_EXCEPTION,
  53202: REMOTE_CONTROL_EXCEPTIONS.ACCESS_TOKEN_INVALID_EXCEPTION,
  53203: REMOTE_CONTROL_EXCEPTIONS.ACCESS_TOKEN_INVALID_EXCEPTION,
  53204: REMOTE_CONTROL_EXCEPTIONS.ACCESS_TOKEN_INVALID_EXCEPTION,
  53205: REMOTE_CONTROL_EXCEPTIONS.ACCESS_TOKEN_INVALID_EXCEPTION,
  53206: REMOTE_CONTROL_EXCEPTIONS.ACCESS_TOKEN_INVALID_EXCEPTION,
  53216: REMOTE_CONTROL_EXCEPTIONS.ACCESS_TOKEN_INVALID_EXCEPTION,
  53300: REMOTE_CONTROL_EXCEPTIONS.ACCESS_TOKEN_INVALID_EXCEPTION,
  53301: REMOTE_CONTROL_EXCEPTIONS.ACCESS_TOKEN_INVALID_EXCEPTION,
  53302: REMOTE_CONTROL_EXCEPTIONS.ACCESS_TOKEN_INVALID_EXCEPTION,
  53303: REMOTE_CONTROL_EXCEPTIONS.ACCESS_TOKEN_INVALID_EXCEPTION,
  53304: REMOTE_CONTROL_EXCEPTIONS.ACCESS_TOKEN_INVALID_EXCEPTION,
  53305: REMOTE_CONTROL_EXCEPTIONS.ACCESS_TOKEN_INVALID_EXCEPTION,
  53306: REMOTE_CONTROL_EXCEPTIONS.ACCESS_TOKEN_INVALID_EXCEPTION,
  53307: REMOTE_CONTROL_EXCEPTIONS.ACCESS_TOKEN_INVALID_EXCEPTION,
  53403: REMOTE_CONTROL_EXCEPTIONS.ACCESS_TOKEN_INVALID_EXCEPTION,
  53404: REMOTE_CONTROL_EXCEPTIONS.ACCESS_TOKEN_INVALID_EXCEPTION,
  53405: REMOTE_CONTROL_EXCEPTIONS.ACCESS_TOKEN_INVALID_EXCEPTION,
  53406: REMOTE_CONTROL_EXCEPTIONS.ACCESS_TOKEN_INVALID_EXCEPTION,
  53407: REMOTE_CONTROL_EXCEPTIONS.ACCESS_TOKEN_INVALID_EXCEPTION,
  53408: REMOTE_CONTROL_EXCEPTIONS.ACCESS_TOKEN_INVALID_EXCEPTION,
}
const FIELD_LENGTH = {
  DEVICE_SETTINGS_NAME_MIN: 5,
  DEVICE_SETTINGS_NAME_MAX: 50,
  DEVICE_SETTINGS_DESCRIPTION_MAX: 500,
  DEVICE_SETTINGS_FEEDBACK_MAX: 500,
  ANDROID_UPDATES_JOB_NAME_MIN: 5,
  ANDROID_UPDATES_JOB_NAME_MAX: 50,
  ANDROID_UPDATES_DESCRIPTION_MAX: 500,
  ANDROID_UPDATES_NOTIFICATION_MAX: 255,
  APP_MANAGE_MIN: 5,
  APP_MANAGE_PACKAGE_MAX: 255,
  APP_MANAGE_URL_MAX: 2000,
  APP_NAME_MIN: 5, // EDCL-214: Duplicate app name need to be atleast 5 characters
  APP_NAME_MAX: 50,
  APP_PACKAGE_MAX: 99,
  APP_VERSION_MIN: 1,
  APP_DESCRIPTION_MAX: 500,
  APP_VERSION_MAX: 1000,
  APP_VERSION_CODE_MIN: 1,
  APP_VERSION_CODE_MAX: 2100000000,
  EHS_DESIGN_NAME_MAX: 50,
  EHS_DESIGN_DESCRIPTION_MAX: 500,
}

const SMARTREPO_JSON = {
  supportedModels:
    'CC600, CC6000, EC30, EC50, EC55, ET51, ET56, L10A, MC20, MC2200, MC2700, MC33x, MC33xR, MC33ax, MC93, PS20, TC21, TC26, TC52, TC52x, TC52ax, TC57, TC57x, TC72, TC77, TC8300, VC83 & WT6300',
}

const REGEX = {
  //CHAR_REGEX_NO_SPACE_ONLY: "[a-zA-Z][a-zA-Z ]+[a-zA-Z]$",
  NO_SPACE_REGEX: '^(?! )[A-Za-z0-9_!@#$&(){}<>?:;\'^%!\\-`.+,/" ]*(?<! )$',
  NUMBER_REGEX: '^[0-9]*$',
  APK_PACKAGE_REGEX: '^([A-Za-z]{1}[A-Za-z\\d_]*\\.)+[A-Za-z][A-Za-z\\d_]*$',
  URL_REGEX:
    '((http|ftp|https):\\/\\/)?[\\w\\-_]+(\\.[\\w\\-_]+)+([\\w\\-\\.,@?^=%&amp;:/~\\+#]*[\\w\\-\\@?^=%&amp;/~\\+#])?',
  ALPHABET_NUMBER_REGEX: /^[a-zA-Z0-9]{1,5}[a-zA-Z0-9_\-.\ ]*$/i,
  ALPHABET_NUMBER_SpecialChar_REGEX: /^[a-zA-Z0-9%$#&_@!.-]{1,5}[a-zA-Z0-9%$#&_@!_\-.\ ]*$/i,
  RE_SpecialChar_REGEX: /^[a-zA-Z0-9%$#&_@.\-! ]+$/i,
  ALPHABET_NUMBER_All_SpecialChar_REGEX: /^[\x20-\x7E]+$/,
  VERSION_CODE_REGEX: /^\d+$/,
}

const FEATURE_MENUS = {
  LICENSED_FEATURE: ['deviceSettings', 'androidUpdates'],
  ANDROID_UPDATE_FEATURE: ['androidUpdates'],
  ZDM_AS_DO_FEATURE: ['deviceSettings'],
  ZEBRA_AUTHORIZED_FEATURE: ['androidUpdates', 'licensing', 'deviceSettings'],
}
const DISABLED_FEATURE_MESSAGE = {
  LICENSE_UNAVAILABLE_BULK_REAPPLY: 'One or more selected devices do not have a valid license.',
  DISABLE_ANDROID_UPDATE_MENU:
    'Lifeguard Enablement enrollment service is not available for Zebra CoreID accounts',
  DISABLE_ANDROID_UPDATE_MENU_ZEBRA:
    'LifeGuard Service is not available for Zebra.com email addresses.',
  DISABLE_ANDROID_UPDATE_MENU_NON_ZEBRA:
    'LifeGuard Service is initializing, please check back in a few minutes.',
  UNLICENSED_MENU: 'License Required',
  DISABLED_NO_ZDM_AS_DO: 'Feature not available; device is enrolled in third-party EMM.',
  UNSUPPORTED_BSP_OS:
    'Minimum OS version not met. Visit "Android Updates" to update to a supported version.',
  DISABLED_NOT_CONNECTED_TO_ZEBRA_SERVICES_TENANT:
    'Admin not connected to Zebra Services. Please go to My Services to set up',
  DISABLED_NOT_CONNECTED_TO_ZEBRA_SERVICES_ADMIN:
    'Admin not connected to Zebra Services. Please contact your Admin',
  NO_DEVICES_TO_EXPORT: 'No devices available to export',
  NO_DEVICE_USERS_TO_EXPORT: 'No device users available to export',
  PERMISSION_RESTRICTION_BY_ADMIN: 'You do not have permission to access.',
  NOACCESS_PERMISSION_TOOLTIP: 'You do not have permission to access.',
  DISABLE_MIX_SELECTION:
    'This operation cannot be applied if the status of any device in the group is "In Progress" or "Created".',
  DISABLE_HUNDRED_DEVICE_LIMIT: 'This operation supports no more than 100 devices at a time',
  LISENCE_REQUIRED_TOOLTIP: 'License Required',
  UPDATE_ZDNA_CLIENT_TOOL_TIP:
    'Update Client in progress. This may take some time. Please check back later',
  HELIX_DEVICE_DISABLE_TOOLTIP: 'Not supported by device',
  STORAGE_NOT_ENABLED_TOOLTIP: 'Zebra Storage not enabled. Contact an administrator for access.',
}

const LGE_TOKEN_ISSUE_MESSAGE = {
  ADMIN_USER_V1:
    'The token for LifeGuard enablement is expired or invalid. The Admin must log in again to reauthorize.',
  ADMIN_USER_V2:
    'The token for LifeGuard enablement is expired or invalid. Admin must reauthorize on the My Services page.',
  TENANT_OWNER_V2:
    'The token for LifeGuard enablement is expired or invalid. Please reauthorize on the My Services page.',
}

const APPLY_SETTING_TYPE = {
  GUIDED_SETUP: 'guidedSetup',
  ADVANCED_SETUP: 'advancedSetup',
  MASTER_PROFILE_SETUP: 'masterProfileSetup',
}

const APPLY_RXLOGGER_TYPE = {
  NEW_LOG: 'createNewLog',
  ADJUST_DEFAULT_SETTINGS: 'adjustDefaultLogSettings',
}

const MISSING_PROFILE_EDIT_TEXT = {
  MISSING_TOOLTIP_TITLE:
    'The app (or app version) associated with this Profile is no longer available. To proceed, edit the Profile to contain a current version of the app.',
  MISSING_TOOLTIP_PD_TITLE:
    'The app (or app version) associated with this Profile is no longer available. To proceed, edit the App Setup of this Sub-profile (or Template) to contain a current version of the app.',
  MISSING_TOOLTIP_MASTER_PD_TITLE:
    'All apps in this Master Profile are no longer available. To proceed, edit the associated Sub Profiles or Template Profiles in App Setup to contain a current version of the app.',
}

const MAX_LENGTH = {
  PROFILE_NAME: '40',
  PROFILE_DESCRIPTION: '150',
  DEVICE_NAMING: 63,
  DEVICE_AUTO_NAMING: 55,
}

const HIDE_BATTERY_HEALTH_STATUS = false
const BATTERY_UN_SUPPORTED_MODELS = ['TC15', 'TN28']

const SESSION_TIMEOUT = 30 * 60 * 1000

const INDEX_SEPERATOR = '$'
const PATH_LITERAL = '/'

const GOOGLE_DRIVE_TOKEN = {
  ACCESSTOKEN: 'valgdat',
  ACCESSTOKEN_EXPIRY: 'valgdate',
}
const ACTION_NAME = {
  START_REMOTE_CONTROL: 'START_REMOTE_CONTROL',
  GEO_LOCATION: 'GEO_LOCATION',
}

const GEO_LOCATION_DETAILS = {
  LOCATE_TIME_OUT: 40000,
  GOOGLE_MAP_LINK: 'https://www.google.com/maps/search/?api=1&query=',
  NOT_ABLE_TO_LOCATE:
    'Unable to locate the device, it is offline or not configured. Try again later.',
  OFFLINE_DEVICE_TIME_OUT: 5000,
}

const REMOTE_CONTROL_MANAGEMENT = {
  ENABLE_AUDIO: false,
  ENABLE_VIDEO: false,
}

const ERROR_MESSAGE = {
  EXTRACTION_FAILED: 'Error: Not a valid APK',
  FILE_ACCESS: 'Got an error while getting access to the file, please try again',
  DRIVE_CONNECTION: 'Unable to connect to Google Drive',
  DUPLICATE_NAME: 'Duplicate App Name',
  UPLOAD_ERROR: 'Error while uploading, kindly try again',
  NOTE_APK: 'Error: Not a valid APK',
  ENROLLMENT_EXPIRE_ERROR: 'Error while expiring enrollment(s)',
  ENROLLMENT_DELETE_ERROR: 'Error while deleting enrollment(s)',
  ENROLLMENT_SELECTION_ERROR: 'You can select upto 5000 enrollment ids only',
  DEVICE_USER_UPDATE_ERROR: 'Error occurred while updating device user(s)',
  ENROLLMENT_REENROLL_ERROR: 'Error occurred while re-enrolling device user(s)',
  ENROLLMENT_KEY_FETCH_ERROR: 'Error occurred while fetching enrollment key',
  ENROLLMENT_KEY_ADD_ERROR: 'Error occurred while adding enrollment key',
  ENROLLMENT_KEY_UPDATE_ERROR: 'Error occurred while updating enrollment key',
  ENROLLMENT_KEY_DELETE_ERROR: 'Error occurred while deleting enrollment key',
  USER_ADD_ERROR: 'Failed to add user. Please try again.',
  IG_PROFILE_FETCH_ERROR: 'Error occurred while fetching IG profile(s)',
  IG_NETWORK_FETCH_ERROR: 'Network Error, please try again later.',
  IG_INVALID_PROFILE_ERROR: 'Invalid IG profile selected. Admin controlled enrollment configuration missing.',
  NO_ELIGIBLE_RE_ENROLLMENT_USERS: 'No eligible device user(s) found for re-enrollment.',
}

const REMOTE_VIDEO_SETTINGS = {
  defaultHeight: 1280,
  defaultWidth: 720,
  PORTRAIT: '1',
  LANDSCAPE: '2',
}

const category = {
  ZEBRA_APPS: 'zebraApps',
  THIRD_PARTY_APPS: 'thirdPartyApps',
}

const DEVICE_SELECTION_COUNT = {
  APP_SETUP_DEVICE_SELECTION_COUNT: 2500,
  DEVICE_SETTING_SELECTION_COUNT: 2500,
  ALLOCATION_SERIALNUMBER: 1000,
  DEVICES_PER_GROUP: 2500,
}

const JOB_SELECTION_COUNT = {
  RX_LOGGER_JOB_SELECTION_COUNT: 2500,
}

const DEVICE_SELECTION_TOOL_TIP_MSG = 'You have reached the maximum limit of 2500 devices'
const SERIAL_NUMBER_TOOLTIP_MESSAGE =
  'You have reached the max 1K device selection for serial number preference'

const zebraApp = {
  DDT: 'com.symbol.selfdiagnostics',
  DDT1: 'com.zebra.mdna.selfdiagnostics',
  EKB: 'com.zebra.mdna.enterprisekeyboard',
  EHS: 'com.symbol.enterprisehomescreen',
  EHS1: 'com.zebra.mdna.enterprisehomescreen',
}
const zebraAppNames = {
  DDT: 'DDT',
  EKB: 'EKB',
  EHS: 'EHS',
}
const TABNAME = {
  EKB: 'EKB',
  EKB_FAV: 'EKB-Favourite',
}
const ZEBRA_APPS_PACKAGE_NAME = {
  DDT: 'com.symbol.selfdiagnostics',
  DDT1: 'com.zebra.mdna.selfdiagnostics',
  EKB: 'com.zebra.mdna.enterprisekeyboard',
  EHS: 'com.symbol.enterprisehomescreen',
  EHS1: 'com.zebra.mdna.enterprisehomescreen',
  EB: 'com.zebra.mdna.enterprisebrowser',
  ZWC: 'com.zebra.workstationconnect.release',
  ELS: 'com.zebra.mdna.els',
}
const deviceEnrollmentCategory = {
  ZDNA_EMM: '1',
  THIRD_PARTY_EMM: '2',
  ZERO_TOUCH: '3',
}

const GA_TRACK_ID = process.env.REACT_APP_GA_TRACK_ID

const PENDO_CONFIG = {
  apiKey: process.env.REACT_APP_PENDO_API_KEY || '',
  scriptBaseUrl: 'https://content.swengagement.zebra.com/agent/static',
}
const PENDO_EVENT_MY_SERVICES_CONNECTION_STATUS = 'My Services Connection Status'
const PENDO_EVENT_DEVICE_SETTINGS_PROFILE_CREATED = 'Device Settings Profile Created'
const PENDO_EVENT_ANDROID_UPDATE_AUTOMATION_OPTION_SELECTED =
  'Android Update Automation Option Selected'
const PENDO_ANDROID_UPDATE_AUTOMATION_MODE_ALWAYS = 'Always Update'
const PENDO_ANDROID_UPDATE_AUTOMATION_MODE_MANUAL = 'Manual Scheduling'
const PENDO_DEVICE_SETTINGS_CREATION_MODE_WIZARD = 'Wizard'
const PENDO_DEVICE_SETTINGS_CREATION_MODE_ADVANCED = 'Advanced'
const PENDO_CONNECTION_STATUS_CONNECTED = 'Connected'
const PENDO_CONNECTION_STATUS_DISCONNECTED = 'Disconnected'
const APP_SETUP_SESSION_APPLY_IDS = 'appSetupSessionApplyDeploymentIds'
const APP_SETUP_DEPLOYED_EVENT = 'App Setup Deployed'
const MASTER_PROFILE_SESSION_APPLY_IDS = 'masterProfileSessionApplyDeploymentIds'
const MASTER_PROFILE_ISSUE_EVENT = 'Master Profile Deployment Issue'
const PENDO_EVENT_ENROLLMENT_BARCODE_GENERATED = 'Enrollment Barcode Generated'
const PENDO_EVENT_ENROLLMENT_BARCODE_EXPIRED = 'Enrollment Barcode Expired'
const PENDO_EVENT_MANAGED_CONFIG_USAGE_MODE_CONFIGURED = 'Managed Configurations Usage Mode Configured'
const PENDO_MANAGED_CONFIG_USAGE_MODE_LABELS = Object.freeze({
  '1': 'On',
  '2': 'Off',
})


const TOGGLE_TYPE = {
  RC_DEVICE_VIEW: 0,
  RC_DESKTOP_VIEW: 1,
}

const BADGE_COLOR_CODES = {
  green: { badge: '#00864F', text: '#1D1E23', bgcolor: '#ECFFF7', border: '#84DAB6' },
  gray: { badge: '#3C414B', text: '#1D1E23', bgcolor: '#F3F6FA', border: '#E0E3E9' },
  gray_light: { badge: '#AFB6C2', text: '#929AA9', bgcolor: '#F3F6FA', border: '#EDEFF4' },
  red: { badge: '#D70015', text: '#1D1E23', bgcolor: '#FFF0F1', border: '#FF8692' },
  blue: { badge: '#0073E6', text: '#1D1E23', bgcolor: '#F1F8FF', border: '#7EBEFF' },
  yellow: { badge: '#FF9500', text: '#1D1E23', bgcolor: '#FFFAF2', border: '#FFD396' },
  purple: { badge: '#FF9500', text: '#1D1E23', bgcolor: '#F7F0FF', border: '#CEA4FF' },
  blue_light: { badge: '#0073E6', text: '#1D1E23', bgcolor: '#F1F8FF', border: '#599FE5' },
  red_light: { badge: '#D70015', text: '#1D1E23', bgcolor: '#FFF0F1', border: '#F36170' },
}

const STATUS_CODE = {
  OK: 200,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500,
  PRECONDITION_FAILED: 412,
  LICENSE_SUCCESS: 1001,
  LICENSE_FAILED: 1003,
  LICENSE_PARTIAL_SUCCESS: 1002,
}
const STATUS = {
  SUCCESS: 'success',
  FAILED: 'failed',
  ERROR: 'error',
  TEMPLATE: 'Template',
  DELETING: 'Deleting',
}

const ZEBRA_ENROLLMENT_STATUS = {
  ENROLLED: 'enrolled',
  NOT_ENROLLED: 'notEnrolled',
  ENROLLING: 'enrolling',
}

const CURRENT_DO = {
  ZDM: 'ZDM',
  OTHERS: 'others',
}

const zDNA_FEATURE = 'dnacloud-feature-std'
const zDNA_STORAGE_FEATURE = 'dnacloud-storage-std'
const restrictedColumnsCount = 1
const VERSION_NOT_SUPPORTED_MSG =
  'This version of the application does not support configuration when installed on devices with a third-party EMM.'
const LGE_ENROLL_BUFFER = 2 * 60 * 1000 //2 minutes
const LGE_ENROLL_WINDOW = 15 * 60 * 1000 //15 mins

const ERROR_MESSAGES_LOGIN = {
  3001: 'Users from this domain are no longer permitted',
  3002: 'Invalid request, kindly try again with proper data',
  3003: 'User not authenticated; Invalid request',
  3004: 'An error occurred while attempting to log in. Kindly try again.',
  3005: 'Duplicate tenants found',
  3006: 'Your invitation has expired! Contact admin for assistance.',
}

const REDIRECTION_FUNCTION = {
  PROCESS_TOKEN: 'processtoken',
}

const REDIRECTION_URL = {
  LOGIN_URL_V2: '/auth/login',
  LOGIN_URL_V1: '/auth/login/legacy',
}

const USER_STATUS_MAP = {
  Joined: 'Joined',
  Invited: 'Invited',
  Expired: 'Expired Invite',
}

const YOUTUBE_LINKS = {
  AUTHORIZATION_WALKTHROUGH: 'https://youtu.be/25zaBeuDdz4',
  INTRO_TO_ZDNA: 'https://youtu.be/KBqm9SbA9dQ',
}

const DEVICE_USER_TYPE = {
  PERSONALL_ASSIGNED: 'Personally Assigned',
  SHARED_DEVICE: 'Shared Device',
}

const DEFAULT_HIDDEN_ZEBRA_APPS = ['com.zebra.mdna.els']

const DEFAULT_ZEBRA_APPS = [
  'com.symbol.selfdiagnostics',
  'com.zebra.mdna.enterprisebrowser',
  'com.symbol.enterprisehomescreen',
  'com.zebra.mdna.enterprisekeyboard',
  'com.zebra.workstationconnect.release',
  'com.symbol.devicecentral',
]

const APPPACKAGENAMES = {
  DEVICE_CENTRAL: 'com.symbol.devicecentral',
  DEVICE_TRACKER: 'com.zebra.mdna.devicetrackercloud',
  WI_AGENT: 'com.zebra.wirelessinsights.agent',
}

const LICENSE_SOURCE = {
  GET_LICENSES: '1',
  ADD_LICENSES: '2',
  SYNC_LICENSES: '3',
}

const DEVICE_USERS_EXPIRY_CAL = 60 * 60 * 1000 // 1 hour
const USER_REQUEST_STATUS_PENDING = 'Pending' // EDCL-293

const LICENSE_MICROSERVICE_MSG = {
  LICENSE_SERVICE_DOWN: 'Connection to the licensing server is lost. Please try again later.',
  GET_LICENSE_ERROR: 'Error while fetching licenses',
  ADD_LICENSE_ERROR: 'Error while adding the Badge ID',
  ADD_LICENSE_SUCCESS: 'License Added Successfully',
  ALLOCATE_LICENSE_ERROR: 'Error occurred while allocating licenses',
  ALLOCATE_LICENSE_SUCCESS: 'Allocated licenses successfully',
  REFRESHING_LICENSE_ERROR: 'Error while performing License Refresh',
  REFRESHING_LICENSE_SUCCESS: 'Refreshed successfully',
}

const LICENSE_MSG_CODE = [4023, 4016, 4027, 4028]
// 4023: Tenant claiming an already claimed badge id, 4016: no licenses to claim
// 4027: Incorrect badge id Instance, 4028: Claiming future dated license

const JOB_TYPE = {
  APPLY_DEVICE_SETTINGS_WIZARD: 'APPLY_DEVICE_SETTINGS_WIZARD',
  APPLY_DEVICE_SETTINGS_ADVANCED: 'APPLY_DEVICE_SETTINGS_ADVANCED',
  APPLY_THIRD_PARTY_AND_ZEBRA_APPS: 'APPLY_THIRD_PARTY_AND_ZEBRA_APPS',
  DELETE_DEVICE_SETTINGS: 'DELETE_DEVICE_SETTINGS',
  DELETE_APP_SETUP_PROFILES: 'DELETE_APP_SETUP_PROFILES',
  DELETE_RX_LOGGER: 'DELETE_RX_LOGGER',
  MY_DEVICES_EXPORT: 'MY_DEVICES_EXPORT',
  DELETE_DEVICES_EXPORT_JOB: 'DELETE_DEVICES_EXPORT_JOB',
  DEVICE_USERS_EXPORT: 'DEVICE_USERS_EXPORT',
  DELETE_DEVICE_USERS_JOB: 'DELETE_DEVICES_USERS_JOB',
  APPLY_DEVICE_MASTER_PROFILE_DEPLOYMENT: 'APPLY_DEVICE_MASTER_PROFILE_DEPLOYMENT',
  DELETE_MASTER_PROFILES: 'DELETE_MASTER_PROFILES',
  BULK_DELETE_MASTER_PROFILES: 'BULK_DELETE_MASTER_PROFILES',
}

const JOB_STATE = {
  CREATING: 'creating',
  DELETING: 'deleting',
}

const USER_ROLE_MANGEMENT_MSG = {
  ROLE_DELETE_SUCCESS: 'Role deleted successfully',
  ROLE_DELETE_ERROR: 'Error occurred while deleting the role',
}

const PERMISSIONS = {
  EDITABLE: 'Editable',
  NO_ACCESS: 'No Access',
  VIEW_ONLY: 'View Only',
  VIEW_WITH_REMOTE_CONTROL: 'View With Remote Control',
}

const PAGE_NAMES = {
  DEVICE_USERS: 'Device Users',
  MY_SERVICES: 'My Services',
  MY_DEVICES: 'My Devices',
  REMOTE_RXLOGGER: 'Remote Rxlogger',
  PROFILE_DEPENDENCY: 'Profile Deployment',
}

const PROFILES_BULK_SELECTION_COUNT = {
  APP_SETUP_ACTIONS_MAX_COUNT: 20,
  MASTER_PROFILE_ACTIONS_MAX_COUNT: 2, //this is required once scalibility confirmed
}

const LONG_RUNNING_LOADER_MSG = {
  MY_APP_LOADER_MESSAGE: 'App Setup profile creation in progress...',
  DEVICE_SETTING_LOADER_MESSAGE: 'Device Settings profile creation in progress...',
  PROFILE_DEPENDENCY_LOADER_MESSAGE: 'Profile creation in progress...',
}
const HTTPS_CALLABLE_TIMEOUT = 540000 // 540 seconds or 9 minutes to override default timeout

const CONNECTION_STATUS = {
  ONLINE: 'Online',
  OFFLINE: 'Offline',
  ONLINEINCAPS: 'ONLINE',
  OFFLINEINCAPS: 'OFFLINE',
  PRESENCE_STATUS: 'presenceStatus',
  ONLINE_STATUS_MESSAGE: 'Device status update within an approx. timeline of 10 mins',
}

const DEVICE_STATUS = {
  UNSUPPORTED_OS: 'Unsupported OS version',
  CLIENT_OUT_OF_DATE: 'DNA Client Out of Date',
  QUERY_OR_CONDITION: '__OR__',
}

const DEPLOYEMENT_STATUS = {
  APPLIED: 'Applied',
  DRAFT: 'Draft',
  INPROGRESS: 'In-Progress',
  ISSUE: 'Issue',
  FAILED: 'Failed',
  SUCCESS: 'Success',
  Unknown: 'Unknown',
  PENDING: 'Pending',
  CREATED: 'Created',
}

const DEVICE_ACTIONS = {
  REMOVE: 'remove',
  REAPPLY: 'reapply',
}

const MASTER_PROFILE_TYPE = {
  DEVICE_SETTING: 'Device Settings',
  APP_SETUP: 'App Setup',
  VARIOUS: 'Various',
}

const REFRESH_TIME_IN_SECONDS = 15

const ZDPI_VERSION_CHECK_FOR_OS = ['11', '13']

const EXPORT_DISABLED = {
  DEVICES_EXPORT_INPROGRESS: 'An export is already in-progress.Kindly try again later',
}

const PAGES_WITH_EDIT_PERMISSIONS = ['remoteRxLogger', 'profileDependency','userRequests']

const SAVE_AS_TEMPLATE_TOOL_TIP =
  'Saving this profile as a template means it can only be sent to a device using "profile deployments".'

// EDCL-214 -->
const DEFAULT_DUPLICATE_PROFILE_NAME_MIN_LENGTH = 5
const DEFAULT_DUPLICATE_PROFILE_NAME_MAX_LENGTH = 50
const DEFAULT_DUPLICATE_PROFILE_TITLE = 'Duplicate Profile'
const DEFAULT_DUPLICATE_PROFILE_OK_TEXT = 'OK'
const DEFAULT_DUPLICATE_PROFILE_CANCEL_TEXT = 'Cancel'
// <--EDCL-214

const AUTO_UPDATE = {
  OPTION: {
    ALL: 'all',
    GROUP: 'group',
  },
  MINIMUM_DEVICE_SUPPORT_BANDWIDTH: 50,
  MAXIMUM_DEVICE_SUPPORT_BANDWIDTH: 499,
  STAGGERED_TIME: 600000, // 10 mins = 600000 ms
  PERCENTAGE_OF_DEVICE: 20,
  TOTAL_GROUPS: 30,
  FEATURE_FLAG_NAME: 'automated_updates',
}

const ZDNA_SUPPORTED_OS_VERSIONS = {
  ANDROID_VERSIONS_WITH_MX: '11',
  ANDROID_VERSIONS_WITH_ZDM: '13',
}

const SPECIAL_CHARACTER_TOOLTIP = {
  PRINTABLE_ASCII_CHAR_TOOLTIP:
    'Supports up to 32 alphanumeric and most printable special characters.',
  LEGACY_SPECIAL_CHAR_TOOLTIP:
    'Enter SSID name for device connection. Supports 1-32 alpha-numeric and special characters: . - % $ # & @ _ ! and space.',
}

const PERSONALIZED_DEVICE_SETTINGS_GUARDIAN_SAFE = 'Personalized Device Settings/Guardian Safe '
const GUARDIAN_SAFE = 'Guardian Safe '

// EDCL-31 -->
const AUTO_CLAIM_MODAL = Object.freeze({
  TITLE: 'Claim Licenses',
  SUB_TITLE: 'Total Licenses',
  DESCRIPTION:
    'Select the products you wish to claim licenses for within ZDNA Cloud by checking the boxes. Toggle ‘Auto Claim Licenses’ to automatically claim future licenses for those products. You can change the auto-claim setting later if needed. Once your selections are made, click ‘Claim’ to register them with ZDNA Cloud.',
})

const MDNA_LICENSE_FEATURE_NAME = 'dnacloud-feature-std'

const RESPONSE = Object.freeze({
  FULLFILLED: 'fulfilled',
  SUCCESS: 'success',
  ERROR: 'error',
})

const BUTTON_LABELS = Object.freeze({
  CLAIMED_OUTSIDE_ZDNA: 'Claimed Outside ZDNA',
  CLAIM: 'Claim',
  ALLOCATE: 'Allocate',
  MANAGE: 'Manage',
})

const CLAIM_LICENSE_MESSAGE = Object.freeze({
  CLAIM_SUCCESS: 'License Claim Successful',
  CLAIM_FAILED: 'License Claim Failed',
  CLAIM_FAILED_INFO_MESSAGE: 'License Claim Failed. Please claim the licenses manually.',
  AUTO_CLAIM_UPDATE_SUCCESS: 'License Auto Claim Update Successful',
  AUTO_CLAIM_UPDATE_FAILED: 'License Auto Claim Update Failed. Please try again later.',
  FAILED_INFO_MESSAGE: 'Sorry, something went wrong. Please try again later.',
})

const AUTO_CLAIM_SWICTH_CONFIRM_MESSAGE = {
  ENABLE_MESSAGE:
    'Are you sure you want to enable auto-claim? \nEnabling this will allow ZDNA to claim {{licenseCount}} licenses for {{productName}} and will auto-claim any future licenses for this product under your Batch ID.',
  DISABLE_MESSAGE:
    'Are you sure you want to disable auto-claim?\nDoing so will not allow ZDNA to claim any future licenses for {{productName}} and you will need to manually claim them if needed.',
}

const AUTO_CLAIM_ACTION_TOOLTIP_MESSAGE =
  'Enable ‘Auto Claim Licenses’ to automatically claim future licenses for those products. You can change the auto-claim setting later if needed.'
const CLAIM_ACTION_TOOLTIP_MESSAGE = 'ZDNA License need to claim'
const LICENSE_PAGE_SUB_TITLE = 'Claim, allocate and manage licenses for Zebra devices and software.'
const LICENSE_PAGE_SUB_TITLE_OLD = 'Acquire, apply and manage Zebra device licenses.'

const LICENSE_EXPIRED = 'Expired'
const LICENSE_VARIOUS = 'Various'
const CLAIM_TYPE = Object.freeze({
  NOT_CLAIMED: 1,
  AUTO_CLAIMED: 2,
  MANUAL_CLAIMED: 3,
})
const ALLOCATION_METHOD_AUTO = 'auto'
const LICENSE_STATUS = Object.freeze({
  ACTIVE: 1,
  EXPIRED: 2,
})
// <-- EDCL-31

// 854
const ENROLLMENT_IDS_SELECTION = 5000

module.exports = {
  ZDNA_SUPPORTED_OS_VERSIONS,
  PROFILE_TYPE,
  COLLECTION_PATH,
  DATABASE,
  FIELD_LENGTH,
  REMOTE_CONTROL_STATUS,
  REMOTE_CONTROL_EXCEPTIONS,
  REMOTE_CONTROL_EXCEPTION_ERRORCODE,
  SMARTREPO_JSON,
  REGEX,
  FEATURE_MENUS,
  APPLY_SETTING_TYPE,
  APPLY_RXLOGGER_TYPE,
  MISSING_PROFILE_EDIT_TEXT,
  LGE,
  CONTENT_TYPE,
  JOB_STATUS_CODE,
  JOB_STATUS,
  MAX_LENGTH,
  HIDE_BATTERY_HEALTH_STATUS,
  RESOURCES,
  INDEX_SEPERATOR,
  GOOGLE_DRIVE_TOKEN,
  ACTION_NAME,
  REMOTE_CONTROL_MANAGEMENT,
  DISABLED_FEATURE_MESSAGE,
  LGE_TOKEN_ISSUE_MESSAGE,
  ERROR_MESSAGE,
  REMOTE_VIDEO_SETTINGS,
  TABNAME,
  zebraApp,
  category,
  zebraAppNames,
  ZEBRA_APPS_PACKAGE_NAME,
  SESSION_TIMEOUT,
  BATTERY_UN_SUPPORTED_MODELS,
  GA_TRACK_ID,
  PENDO_CONFIG,
  PENDO_EVENT_MY_SERVICES_CONNECTION_STATUS,
  PENDO_EVENT_DEVICE_SETTINGS_PROFILE_CREATED,
  PENDO_EVENT_ANDROID_UPDATE_AUTOMATION_OPTION_SELECTED,
  PENDO_ANDROID_UPDATE_AUTOMATION_MODE_ALWAYS,
  PENDO_ANDROID_UPDATE_AUTOMATION_MODE_MANUAL,
  PENDO_DEVICE_SETTINGS_CREATION_MODE_WIZARD,
  PENDO_DEVICE_SETTINGS_CREATION_MODE_ADVANCED,
  PENDO_CONNECTION_STATUS_CONNECTED,
  PENDO_CONNECTION_STATUS_DISCONNECTED,
  APP_SETUP_SESSION_APPLY_IDS,
  APP_SETUP_DEPLOYED_EVENT,
  MASTER_PROFILE_SESSION_APPLY_IDS,
  MASTER_PROFILE_ISSUE_EVENT,
  PENDO_EVENT_ENROLLMENT_BARCODE_GENERATED,
  PENDO_EVENT_ENROLLMENT_BARCODE_EXPIRED,
  PENDO_EVENT_MANAGED_CONFIG_USAGE_MODE_CONFIGURED,
  PENDO_MANAGED_CONFIG_USAGE_MODE_LABELS,
  deviceEnrollmentCategory,
  TOGGLE_TYPE,
  BADGE_COLOR_CODES,
  LICENSES,
  DESIGNS,
  STATUS_CODE,
  STATUS,
  zDNA_FEATURE,
  zDNA_STORAGE_FEATURE,
  restrictedColumnsCount,
  VERSION_NOT_SUPPORTED_MSG,
  PATH_LITERAL,
  ZEBRA_ENROLLMENT_STATUS,
  CURRENT_DO,
  LGE_ENROLL_BUFFER,
  ERROR_MESSAGES_LOGIN,
  REDIRECTION_FUNCTION,
  REDIRECTION_URL,
  USER_STATUS_MAP,
  YOUTUBE_LINKS,
  DEVICE_USER_TYPE,
  DEFAULT_HIDDEN_ZEBRA_APPS,
  DEFAULT_ZEBRA_APPS,
  LICENSE_SOURCE,
  DEVICE_USERS_EXPIRY_CAL,
  USER_REQUEST_STATUS_PENDING, // EDCL-293
  LICENSE_MICROSERVICE_MSG,
  LGE_ENROLL_WINDOW,
  LICENSE_MSG_CODE,
  JOB_TYPE,
  DEVICE_SELECTION_COUNT,
  JOB_SELECTION_COUNT,
  DEVICE_SELECTION_TOOL_TIP_MSG,
  JOB_STATE,
  PAGES_LIST,
  DEFAULT_SYSTEM_ROLES,
  APPPACKAGENAMES,
  USER_ROLE_MANGEMENT_MSG,
  PERMISSIONS,
  PAGE_NAMES,
  CHECK_LATEST_APP_VERSION,
  CHECK_PACKAGE_SHORT_FORM,
  SERIAL_NUMBER_TOOLTIP_MESSAGE,
  PROFILES_BULK_SELECTION_COUNT,
  LONG_RUNNING_LOADER_MSG,
  HTTPS_CALLABLE_TIMEOUT,
  CONNECTION_STATUS,
  DEVICE_STATUS,
  CHECK_LATEST_APP_BASE_VERSION,
  CHECK_PACKAGE_SHORT_FORM_BASE_VERSION,
  CHECK_LATEST_APP_VERSION_THIRD_PARTY,
  CHECK_PACKAGE_SHORT_FORM_THIRD_PARTY,
  VALID_HOST,
  GEO_LOCATION_DETAILS,
  REFRESH_TIME_IN_SECONDS,
  CHECK_LATEST_APP_VERSION_A14,
  CHECK_PACKAGE_SHORT_FORM_A14,
  ZDPI_VERSION_CHECK_FOR_OS,
  EXPORT_DISABLED,
  PAGES_WITH_EDIT_PERMISSIONS,
  SAVE_AS_TEMPLATE_TOOL_TIP,
  DEPLOYEMENT_STATUS,
  MASTER_PROFILE_TYPE,
  AUTO_UPDATE,
  DEVICE_ACTIONS,
  DEFAULT_DUPLICATE_PROFILE_NAME_MIN_LENGTH,
  DEFAULT_DUPLICATE_PROFILE_NAME_MAX_LENGTH,
  DEFAULT_DUPLICATE_PROFILE_TITLE,
  DEFAULT_DUPLICATE_PROFILE_OK_TEXT,
  DEFAULT_DUPLICATE_PROFILE_CANCEL_TEXT,
  PROFILE_DEPENDENCY,
  SPECIAL_CHARACTER_TOOLTIP,
  // EDCL-21 -->
  PERSONALIZED_DEVICE_SETTINGS_GUARDIAN_SAFE,
  GUARDIAN_SAFE,
  // EDCL-31 -->
  MDNA_LICENSE_FEATURE_NAME,
  AUTO_CLAIM_MODAL,
  CLAIM_LICENSE_MESSAGE,
  AUTO_CLAIM_SWICTH_CONFIRM_MESSAGE,
  AUTO_CLAIM_ACTION_TOOLTIP_MESSAGE,
  CLAIM_ACTION_TOOLTIP_MESSAGE,
  LICENSE_PAGE_SUB_TITLE,
  LICENSE_PAGE_SUB_TITLE_OLD,
  LICENSE_EXPIRED,
  CLAIM_TYPE,
  ALLOCATION_METHOD_AUTO,
  LICENSE_VARIOUS,
  LICENSE_STATUS,
  RESPONSE,
  BUTTON_LABELS,
  // <-- EDCL-31
  // EDCL-854 -->
  ENROLLMENT_IDS_SELECTION
  // <-- EDCL-854
}
